import React from "react";
import BlogTwelve from "../component/BlogTwelve";

function BlogTwelveContainer() {
  return <BlogTwelve />;
}
export default BlogTwelveContainer;
